import React from "react";
import styled from "styled-components";
import {dark_green} from "../colors";

const MobileResultPreview = (props) => {
    const searchAndClose = () => {
        // Hacky approach because ref is not supported, and we are outside the SearchForm component
        const forms = document.getElementsByClassName('workplace-formifly-form');

        if (forms.length) {
            forms[0].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
        props.setIsSearchFormVisible(false);
    }

    return <MobileResultPreviewBox>
        <MobileResultPreviewContent>
            <ResultCount>{props.totalResults} Ergebnisse</ResultCount>
            <ShowResults onClick={searchAndClose}>anzeigen</ShowResults>
        </MobileResultPreviewContent>
    </MobileResultPreviewBox>
}

const MobileResultPreviewBox = styled.div`
    position: fixed;
    bottom: 0;
    left: 50px;
    right: 50px;
    background-color: ${dark_green};
    z-index: 100000;
    border-radius: 20px 20px 0  0;
    font-size: 1.2rem;

    @media (min-width: 900px) {
        display: none;
    }
`;

const MobileResultPreviewContent = styled.div`
    display: flex;
`;

const ResultCount = styled.p`
    flex-grow: 1;
    padding-left: 20px;
`;

const ShowResults = styled.button`
    background-color: transparent;
    color: white;
    border: 0;
    padding-right: 20px;
    text-transform: uppercase;


    &:before {
        content: '→   ';
    }
`;

export default MobileResultPreview;
